const StringUtils = {
  /**
   * Ensure input is a valid string (fallback to empty string if null/undefined)
   * @param {any} str - Input value
   * @returns {string} - Valid string
   */
  validateString: (str) => (typeof str === "string" ? str : str == null ? "" : String(str)),

  /**
   * Get the last N characters from a string
   * @param {string} str - The input string
   * @param {number} n - Number of characters to extract from the end
   * @returns {string} - Extracted substring
   */
  getLastNChars: (str, n) => StringUtils.validateString(str).slice(-n),

  /**
   * Get the first N characters from a string
   * @param {string} str - The input string
   * @param {number} n - Number of characters to extract from the beginning
   * @returns {string} - Extracted substring
   */
  getFirstNChars: (str, n) => StringUtils.validateString(str).slice(0, n),

  /**
   * Get a substring from index `start` to `end`
   * @param {string} str - The input string
   * @param {number} start - Start index (inclusive)
   * @param {number} end - End index (exclusive)
   * @returns {string} - Extracted substring
   */
  getSubstring: (str, start, end) => StringUtils.validateString(str).slice(start, end),

  /**
   * Check if a string contains a specific text
   * @param {string} str - The input string
   * @param {string} text - The text to search for
   * @returns {boolean} - True if the text is found, otherwise false
   */
  findText: (str, text) => StringUtils.validateString(str).includes(StringUtils.validateString(text)),

  /**
   * Find all occurrences of a substring in a string
   * @param {string} str - The input string
   * @param {string} text - The substring to search for
   * @returns {number[]} - Array of starting indices where `text` appears in `str`
   */
  findAllOccurrences: (str, text) => {
    str = StringUtils.validateString(str);
    text = StringUtils.validateString(text);
    if (!text) return []; // Prevent infinite loop if text is empty

    const positions = [];
    let index = str.indexOf(text);
    while (index !== -1) {
      positions.push(index);
      index = str.indexOf(text, index + 1);
    }
    return positions;
  },

  /**
   * Replace all occurrences of a substring in a string
   * @param {string} str - The input string
   * @param {string} oldText - The text to be replaced
   * @param {string} newText - The new text to replace `oldText`
   * @returns {string} - Modified string with replacements
   */
  replaceText: (str, oldText, newText) => {
    str = StringUtils.validateString(str);
    oldText = StringUtils.validateString(oldText);
    newText = StringUtils.validateString(newText);
    return str.split(oldText).join(newText);
  },
};

export default StringUtils;
